<template>
	<div>
		<el-dialog title="修改名称和图标" :visible.sync="dialogVisible" width="30%" append-to-body @closed="closed">
			<el-input v-model="tagItem.NAME" size="mini"></el-input>
			<img v-if="isIcons && tagItem.ICON" :src="isIcon(tagItem.ICON)" alt="1" style="width: 22px;height: 22px;">
			<img v-else :src="isIcon(tubiaoClass)" alt="" style="width: 22px;height: 22px;">
			<selectIcon ref="selectIcon" @getVal="valGet"></selectIcon>
			<el-button class="selectIcon" type="text" size="mini" @click="select">选择图标</el-button>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
				<el-button type="primary" @click="sure" size="mini">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {UpdateTemplate} from "@/api/modules/basicData/task";
	import selectIcon from './selectIcon'
	export default {
		data() {
			return {
				dialogVisible: false,
				// tagItem: {},
				tubiaoId: '',
				tubiaoClass: '',
				isIcons: true,
			};
		},
		components:{
			selectIcon
		},
		methods: {
			closed(){
				this.tubiaoClass = ''
			},
			select(){
				this.$refs.selectIcon.innerVisible = true;
			},
			valGet(val){
				this.tubiaoClass = val;
				this.isIcons = false;
			},
			isIcon(val){
				if(val){
					if(val.indexOf('icon-')==-1)
					return require("@/assets/icon/"+val)
				}
			},
			sure(){
				console.log(this.tagItem);
				let obj = this.tagItem;
				if(this.tubiaoClass){
					obj.ICON = this.tubiaoClass;
				}
				
				UpdateTemplate(obj,this.category).then((res) => {
					// console.log(res)
					if(res == 1){
						// this.$store.commit("getAllTemplateLeft");
						// this.$emit('getAllTemLeft')
						this.$store.commit("getAllTemplateLeft");
					}
				})
				this.dialogVisible = false;
			}
		},
		mounted(){
			
		},
		computed: {
			tagItem: function() {
				return this.$store.state.task.tagItem
			},
			category: function() {
				return this.$store.state.task.category
			},
		}
	};
</script>

<style scoped>
	.tubiao_div {
		word-wrap: break-word;
	}
	.templateIcon{
		margin-right: 5px;
		margin-bottom: 5px;
	}
	.templateIcon:hover{
		color: #409EFF !important;
	}
	.selectIcon{
		margin-top: 20px;
	}
</style>
